import React from 'react';
import * as _ from 'lodash'
import * as actions from '../actions';
import * as jobActions from '../jobActions';import * as jobCostActions from '../jobCostActions';import componentServices from '../componentServices';
import enums from '../enum';
import { getModel, ModelCollection } from '../store';
import globalRelay from '../globalRelay';
import jobCostFactory from '../models/jobCostModel';

//helper function for dev purposes only - no longer works
async function updateInstallRates (e) {
	e.preventDefault();

	let jobCosts = await jobCostActions.utilFetch({ installratechange: true });
	let lastId = 0;

	while (jobCosts && jobCosts.length) {
		for (const jobCost of jobCosts) {
			lastId = jobCost.relayId > lastId ? jobCost.relayId : lastId;
			try {
				if (jobCost.jobKey && jobCost.installationMode !== 'none') {
					let job = getModel({ collection: ModelCollection.jobs, key: jobCost.jobKey });
					const installConfigName = jobCost.getSettingValue(enums.jobCostSettingGroups.General, 'installationConfigDefinition');

					if (!installConfigName) {
						console.log(`could not update install rates for ${jobCost.relayId}: no install config name`); // eslint-disable-line no-console
						continue;
					}
					let installationConfig = componentServices.store.getIn(['model', 'config', _.camelCase(installConfigName)]);

					if (installationConfig === undefined) {
						await actions.fetchConfig({ name: installConfigName });
					}

					installationConfig = componentServices.store.getIn(['model', 'config', _.camelCase(installConfigName)]);
					if (!installationConfig) {
						console.log(`could not update install rates for ${jobCost.relayId}: could not fetch ${installConfigName}`); // eslint-disable-line no-console
						continue;
					}

					if (!job) {
						await jobActions.fetchJob({ key: jobCost.jobKey });

						job = getModel({ collection: ModelCollection.jobs, key: jobCost.jobKey });
					}

					if (job) {
						const globalConfig = globalRelay.config!.withVariant(jobCost.companyVariant);
						const installSettings = globalConfig.jobCostSettings.installation;
						const businessSegmentName = enums.businessSegments.getName(job.businessSegment).toLowerCase();
						const segmentKey = (job.businessSegment === enums.businessSegments.Retail && job.isRenovation) ? `${businessSegmentName}Reno` : businessSegmentName;
						const installationUnitPrice = installSettings.unitPrice[segmentKey];
						const configItems:any[] = [];

						for (const configItem of (installationConfig.items || installationConfig)) {
							const isFixedCost = typeof configItem.cost !== 'undefined';
							const filledItem = _.assign({ cost: isFixedCost ? Number(configItem.cost) : Number(configItem.costFactor) * installationUnitPrice, quantity: 0 }, configItem);

							configItems.push(filledItem);
						}

						if (jobCost.installationMode !== 'none') {
							const updated = jobCostFactory(jobCost.toDocument());
							updated.installationUnitPrice = installationUnitPrice;

							_.forEach(updated.installSheets, s => {
								s.unitCost = updated.installationUnitPrice;

								// only alter items that use the costFactor - autoCalculated items are on there own
								for (const item of configItems.filter(i => i.costFactor && !i.isAutoCalculated)) {
									const lineItem = _.find(updated.lineItems, { type: item.type, group: item.group, description: item.description, installSheetKey: s.key });
									if (lineItem) {
										lineItem.cost = s.unitCost * item.costFactor;
										globalRelay.triggerJobCostLineUpdate(lineItem, 'cost', updated);
									}
								}
							});

							const patch = updated.getPatch(jobCost);

							if (patch.length) {
								await jobCostActions.saveJobCost({ jobCost: updated.toDocument(), patch });
							}
						}
					}
				}
			}
			catch (err) {
				console.warn(err); // eslint-disable-line no-console
			}
		}

		if (confirm('Finished last batch, continue?')) {
			jobCosts = await jobCostActions.utilFetch({ installratechange: true, lastId });
		}
		else {
			jobCosts = [];
		}
	}

	alert('process complete');
}

export default () => {
	return (<div>
		<section>
			<header><span>System Util</span></header>
			<div className="content">
				<div className="actions">
					<button onClick={ updateInstallRates }><span>Bulk Update Installation costs</span></button>
				</div>
			</div>
		</section>
	</div>);
};